import * as React from 'react';
import {Svg, 
  G,
  Path,
  Mask,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
} from 'react-native-svg';

const JCBCard = props => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={46}
      height={30}
      viewBox="0 0 46 30"
      fill="none"
      {...props}>
      <G clipPath="url(#a)">
        <Path
          fill="#F4F6F7"
          fillRule="evenodd"
          d="M.138 2.114C.138.947 1.084 0 2.252 0h40.875c1.168 0 2.114.947 2.114 2.114v25.37a2.114 2.114 0 0 1-2.114 2.115H2.252a2.114 2.114 0 0 1-2.114-2.114V2.115Z"
          clipRule="evenodd"
        />
        <Path
          fill="#E5E5E5"
          fillOpacity={0.01}
          fillRule="evenodd"
          d="M.138 1.5a1.5 1.5 0 0 1 1.5-1.5h29a1.5 1.5 0 0 1 1.5 1.5v18a1.5 1.5 0 0 1-1.5 1.5h-29a1.5 1.5 0 0 1-1.5-1.5v-18Z"
          clipRule="evenodd"
        />
        <Path
          fill="url(#b)"
          fillRule="evenodd"
          d="M29.38 8.459c-.144 0-.287.005-.427.019a2.363 2.363 0 0 0-1.44.68c-.275.28-.466.628-.547 1-.04.184-.045.368-.045.554V12.721c0 .047-.013.051.044.051h2.638c.288 0 .578-.01.865.014.283.024.571.098.8.26a.873.873 0 0 1 .342.974c-.105.344-.421.575-.783.671-.04.01-.08.02-.122.028-.023.004-.055.003-.077.013-.01.004-.037.01-.017.027.005.005.026.005.04.004h.016c.113.01.226.029.336.057.337.085.664.267.82.567.184.354.09.794-.208 1.069-.235.216-.563.327-.887.364-.163.018-.327.014-.49.014H27.045c-.026 0-.097-.011-.117 0-.012.007-.008.017-.008.035v4.222c0 .008-.006.043 0 .05.007.007.066 0 .08 0h3.19c.523 0 1.022-.125 1.446-.419a2.084 2.084 0 0 0 .919-1.773V8.466H29.945c-.174 0-.352-.006-.528-.006h-.038Zm-1.05 5.09c-.005.017 0 .058 0 .078v1.034c0 .027-.008.122.005.135.011.012.061 0 .076 0H28.966c.103 0 .206.003.31 0a.411.411 0 0 0 .342-.193.854.854 0 0 0 .108-.583.756.756 0 0 0-.082-.25.423.423 0 0 0-.317-.232c-.058-.007-.117-.004-.175-.004h-.809c-.006 0-.009.002-.013.014Zm.63 1.252h-.63v1.174c0 .02-.006.06 0 .078.008.027.087.012.112.012H29.233c.103 0 .202-.01.293-.087a.681.681 0 0 0 .206-.445c.022-.21-.028-.429-.138-.572a.386.386 0 0 0-.317-.16h-.317Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={7}
          height={14}
          x={26}
          y={8}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}>
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M29.38 8.459c-.144 0-.287.005-.427.019a2.363 2.363 0 0 0-1.44.68c-.275.28-.466.628-.547 1-.04.184-.045.368-.045.554V12.721c0 .047-.013.051.044.051h2.638c.288 0 .578-.01.865.014.283.024.571.098.8.26a.873.873 0 0 1 .342.974c-.105.344-.421.575-.783.671-.04.01-.08.02-.122.028-.023.004-.055.003-.077.013-.01.004-.037.01-.017.027.005.005.026.005.04.004h.016c.113.01.226.029.336.057.337.085.664.267.82.567.184.354.09.794-.208 1.069-.235.216-.563.327-.887.364-.163.018-.327.014-.49.014H27.045c-.026 0-.097-.011-.117 0-.012.007-.008.017-.008.035v4.222c0 .008-.006.043 0 .05.007.007.066 0 .08 0h3.19c.523 0 1.022-.125 1.446-.419a2.084 2.084 0 0 0 .919-1.773V8.466H29.945c-.174 0-.352-.006-.528-.006h-.038Zm-1.05 5.09c-.005.017 0 .058 0 .078v1.034c0 .027-.008.122.005.135.011.012.061 0 .076 0H28.966c.103 0 .206.003.31 0a.411.411 0 0 0 .342-.193.854.854 0 0 0 .108-.583.756.756 0 0 0-.082-.25.423.423 0 0 0-.317-.232c-.058-.007-.117-.004-.175-.004h-.809c-.006 0-.009.002-.013.014Zm.63 1.252h-.63v1.174c0 .02-.006.06 0 .078.008.027.087.012.112.012H29.233c.103 0 .202-.01.293-.087a.681.681 0 0 0 .206-.445c.022-.21-.028-.429-.138-.572a.386.386 0 0 0-.317-.16h-.317Z"
            clipRule="evenodd"
          />
        </Mask>
        <Path
          fill="url(#d)"
          fillRule="evenodd"
          d="M14.738 8.487a2.387 2.387 0 0 0-.908.335 2.096 2.096 0 0 0-1.005 1.756V15.762c0 .039 0 .03.048.051.053.024.106.046.16.068.427.175.877.309 1.342.361.335.038.692.049 1.007-.075a.992.992 0 0 0 .559-.518c.066-.152.085-.312.085-.475v-2.338c0-.012-.008-.053 0-.063.01-.014.088-.005.11-.005h1.855v2.443c0 .243-.039.487-.146.711-.108.223-.28.411-.492.555-.516.347-1.199.438-1.822.464a9.981 9.981 0 0 1-1.337-.038 9.15 9.15 0 0 1-1.369-.217v4.412c0 .007-.005.037 0 .042.01.01.094 0 .11 0h2.635c.388 0 .787.025 1.166-.064.664-.155 1.229-.59 1.516-1.165.158-.315.21-.65.21-.995V8.46h-3.209a3.45 3.45 0 0 0-.515.028Z"
          clipRule="evenodd"
        />
        <Mask
          id="e"
          width={7}
          height={14}
          x={12}
          y={8}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}>
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M14.738 8.487a2.387 2.387 0 0 0-.908.335 2.096 2.096 0 0 0-1.005 1.756V15.762c0 .039 0 .03.048.051.053.024.106.046.16.068.427.175.877.309 1.342.361.335.038.692.049 1.007-.075a.992.992 0 0 0 .559-.518c.066-.152.085-.312.085-.475v-2.338c0-.012-.008-.053 0-.063.01-.014.088-.005.11-.005h1.855v2.443c0 .243-.039.487-.146.711-.108.223-.28.411-.492.555-.516.347-1.199.438-1.822.464a9.981 9.981 0 0 1-1.337-.038 9.15 9.15 0 0 1-1.369-.217v4.412c0 .007-.005.037 0 .042.01.01.094 0 .11 0h2.635c.388 0 .787.025 1.166-.064.664-.155 1.229-.59 1.516-1.165.158-.315.21-.65.21-.995V8.46h-3.209a3.45 3.45 0 0 0-.515.028Z"
            clipRule="evenodd"
          />
        </Mask>
        <Path
          fill="url(#f)"
          fillRule="evenodd"
          d="M22.012 8.464a2.432 2.432 0 0 0-.72.153 2.248 2.248 0 0 0-1.173 1.003 1.997 1.997 0 0 0-.245.953v2.767a1.96 1.96 0 0 1 .223-.156c.378-.23.818-.36 1.26-.436.36-.062.727-.09 1.093-.096a9.2 9.2 0 0 1 1.078.041 11.442 11.442 0 0 1 1.22.192c.023.005.113.012.125.028.01.012 0 .06 0 .074V13.807a4.803 4.803 0 0 0-1.384-.43c-.573-.084-1.223-.081-1.719.237-.479.306-.646.85-.594 1.368.05.504.351.936.858 1.137.501.2 1.082.172 1.607.076a5.16 5.16 0 0 0 1.232-.403V16.612c0 .014.01.061 0 .074-.012.016-.103.023-.126.027a11.66 11.66 0 0 1-1.37.206c-.36.03-.723.036-1.084.023a6.598 6.598 0 0 1-1.098-.122c-.475-.097-.948-.264-1.321-.56v4.816c0 .01-.007.051 0 .06.015.017.143.003.173.003h2.345c.33 0 .666.016.996-.006.597-.04 1.163-.3 1.557-.718.377-.4.564-.907.564-1.434V8.46H22.436l-.206-.001c-.073 0-.145.001-.218.005Z"
          clipRule="evenodd"
        />
        <Mask
          id="g"
          width={7}
          height={14}
          x={19}
          y={8}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}>
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M22.012 8.464a2.432 2.432 0 0 0-.72.153 2.248 2.248 0 0 0-1.173 1.003 1.997 1.997 0 0 0-.245.953v2.767a1.96 1.96 0 0 1 .223-.156c.378-.23.818-.36 1.26-.436.36-.062.727-.09 1.093-.096a9.2 9.2 0 0 1 1.078.041 11.442 11.442 0 0 1 1.22.192c.023.005.113.012.125.028.01.012 0 .06 0 .074V13.807a4.803 4.803 0 0 0-1.384-.43c-.573-.084-1.223-.081-1.719.237-.479.306-.646.85-.594 1.368.05.504.351.936.858 1.137.501.2 1.082.172 1.607.076a5.16 5.16 0 0 0 1.232-.403V16.612c0 .014.01.061 0 .074-.012.016-.103.023-.126.027a11.66 11.66 0 0 1-1.37.206c-.36.03-.723.036-1.084.023a6.598 6.598 0 0 1-1.098-.122c-.475-.097-.948-.264-1.321-.56v4.816c0 .01-.007.051 0 .06.015.017.143.003.173.003h2.345c.33 0 .666.016.996-.006.597-.04 1.163-.3 1.557-.718.377-.4.564-.907.564-1.434V8.46H22.436l-.206-.001c-.073 0-.145.001-.218.005Z"
            clipRule="evenodd"
          />
        </Mask>
      </G>
      <Defs>
        <LinearGradient
          id="b"
          x1={32.556}
          x2={27.109}
          y1={7.91}
          y2={7.91}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#43C311" />
          <Stop offset={1} stopColor="#288C00" />
        </LinearGradient>
        <LinearGradient
          id="d"
          x1={12.838}
          x2={18.532}
          y1={21.176}
          y2={21.176}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#21469E" />
          <Stop offset={1} stopColor="#1E81EB" />
        </LinearGradient>
        <LinearGradient
          id="f"
          x1={25.509}
          x2={19.871}
          y1={8.459}
          y2={8.459}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#F42D3E" />
          <Stop offset={1} stopColor="#9C0017" />
        </LinearGradient>
        <ClipPath id="a">
          <Path fill="#fff" d="M.138 0H45.24v29.599H.138z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default JCBCard;
